// theme.js - Phase 1 minimal global behaviors.
// Future phases add cart subscriber, page-transition helpers, etc.
// No globals. No window.theme. Communicate via DOM events when needed.

// Skip-link enhancement: when the link is activated, the focus
// jumps to <main> and the link visually retreats. The native
// behavior is a hash-jump; this also moves keyboard focus there
// reliably across browsers.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.skip-to-content');
  if (!link) return;
  const target = document.getElementById('main-content');
  if (!target) return;
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: false });
  target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
});
